export default __webpack_public_path__ + "static/media/makeLessIcon.7f76bc3b.svg";